var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZunuMailAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_179540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_179540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.56111 15.5273C3.14016 15.5273 2.78386 15.3815 2.49219 15.0898C2.20052 14.7982 2.05469 14.4419 2.05469 14.0209V4.53377C2.05469 4.11282 2.20052 3.75651 2.49219 3.46485C2.78386 3.17318 3.14016 3.02734 3.56111 3.02734H16.3816C16.8026 3.02734 17.1589 3.17318 17.4505 3.46485C17.7422 3.75651 17.888 4.11282 17.888 4.53377V14.0209C17.888 14.4419 17.7422 14.7982 17.4505 15.0898C17.1589 15.3815 16.8026 15.5273 16.3816 15.5273H3.56111ZM16.638 5.47923L10.3768 9.48726C10.3127 9.52358 10.2465 9.55216 10.1781 9.57299C10.1097 9.59382 10.0408 9.60424 9.97136 9.60424C9.90191 9.60424 9.833 9.59382 9.76463 9.57299C9.69625 9.55216 9.63002 9.52358 9.56592 9.48726L3.30467 5.47923V14.0209C3.30467 14.0957 3.32871 14.1572 3.3768 14.2052C3.42488 14.2533 3.48632 14.2774 3.56111 14.2774H16.3816C16.4564 14.2774 16.5178 14.2533 16.5659 14.2052C16.614 14.1572 16.638 14.0957 16.638 14.0209V5.47923ZM9.97136 8.44401L16.5098 4.27733H3.43288L9.97136 8.44401ZM3.30467 5.67152V4.71883V4.74366V4.71722V5.67152Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.95312,
    y: 9.23438,
    width: 8.74023,
    height: 8.74023,
    rx: 1.09253,
    fill: "url(#paint0_radial_1_179540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6484 15.5223C10.6484 14.6103 11.3877 13.8711 12.2996 13.8711C13.2115 13.8711 13.9508 14.6103 13.9508 15.5223V16.8823C13.9508 17.0486 13.8159 17.1834 13.6496 17.1834H10.9496C10.7833 17.1834 10.6484 17.0486 10.6484 16.8823V15.5223Z",
    fill: "#7AA2F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9766 15.715C17.9766 16.6059 17.2543 17.3281 16.3634 17.3281C15.4725 17.3281 14.7503 16.6059 14.7503 15.715L14.7503 14.3864C14.7503 14.2239 14.882 14.0922 15.0445 14.0922L17.6824 14.0922C17.8449 14.0922 17.9766 14.2239 17.9766 14.3864L17.9766 15.715Z",
    fill: "#497FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6484 10.1053C10.6484 10.0342 10.7061 9.97656 10.7772 9.97656H13.2401C13.3547 9.97656 13.4122 10.1151 13.3313 10.1962L10.8684 12.6665C10.7873 12.7478 10.6484 12.6904 10.6484 12.5756L10.6484 10.1053Z",
    fill: "#405FEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 13.1603C13.9531 13.2314 13.8955 13.2891 13.8244 13.2891L11.3615 13.2891C11.2469 13.2891 11.1894 13.1506 11.2703 13.0694L13.7332 10.5991C13.8142 10.5178 13.9531 10.5752 13.9531 10.69L13.9531 13.1603Z",
    fill: "#405FEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9766 11.6379C17.9766 12.5498 17.2373 13.2891 16.3254 13.2891C15.4135 13.2891 14.6742 12.5498 14.6742 11.6379L14.6742 10.2779C14.6742 10.1116 14.8091 9.97682 14.9754 9.97682L17.6755 9.97682C17.8418 9.97682 17.9766 10.1116 17.9766 10.2779L17.9766 11.6379Z",
    fill: "#497FEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_179540",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2853 13.159) rotate(89.9326) scale(10.2831 10.2832)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6DFE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZunuMailAcc);
export default __webpack_public_path__ + "static/media/zunuMailAcc.5ae785815799c2fe1ff67917923aaef9.svg";
export { ForwardRef as ReactComponent };